<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList" :actions="actions">
      <div slot="content-buttons">
        <Button _key="btnproductUnitOfMeasurementCreate" title="Unidade de Medida" classIcon="fas fa-plus-circle"
          type="primary" size="small" :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Unidade de Medida" :width="600" :height="250"
      v-show="showModal('productUnitOfMeasurementCreateUpdate')">
      <UnitOfMeasurementCreateUpdate />
    </Modal>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import UnitOfMeasurementCreateUpdate from "../../../components/modules/stock/unit-of-measurement/UnitOfMeasurementCreateUpdate.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ProductUnitOfMeasurementView",
  components: {
    ViewTemplateConfiguration,
    Button,
    Modal,
    UnitOfMeasurementCreateUpdate,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/stock/unit-of-measurement/get-all",
        urlDeleteAllApi: "/api/v1/stock/unit-of-measurement/delete",
        headerTable: [
          {
            field: "name",
            title: "Nome",
            type: "link",
            iconSearch: true,
            eventName: "productUnitOfMeasurementUpdate",
          },
          {
            field: "typeName",
            title: "Tipo",
            type: "text",
            iconSearch: false,
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/stock/unit-of-measurement/delete", method: "delete", },
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    create() {
      this.openModal("productUnitOfMeasurementCreateUpdate");
      this.addEvent({ name: "productUnitOfMeasurementCreate" });
      this.removeLoading(["btnproductUnitOfMeasurementCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "productUnitOfMeasurementUpdate")
          this.openModal("productUnitOfMeasurementCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
